// This file contains events that are used for block communication
// but are not exposed for builders

interface InternalEvent<T> {
    create(payload: T): CustomEvent<T>;
    subscribe(
        target: EventTarget,
        handler: (event: CustomEvent<T>) => void,
        options?: boolean | AddEventListenerOptions,
    ): () => void;
}

function createInternalEvent<T>(name: string): InternalEvent<T> {
    return {
        create(payload) {
            return new CustomEvent(name, { detail: payload });
        },
        subscribe(target, handler, options) {
            // @ts-expect-error: Suppressed automatically in TS 5.8 to 6 migration
            target.addEventListener(name, handler, options);

            return () => {
                // @ts-expect-error: Suppressed automatically in TS 5.8 to 6 migration
                target.removeEventListener(name, handler, options);
            };
        },
    };
}

export const redirectParentEvent = createInternalEvent<{ destination: string }>("REDIRECT_PARENT");

/**
 * Dispatched on the parent window by a page embedded in an OpenPageDialog when it opens or closes a
 * panel against its right edge. The host paints its own controls over the iframe but can't see into
 * it, so it has to be told to get out of the way.
 */
export const embeddedRightPanelEvent = createInternalEvent<{ isOpen: boolean }>("EMBEDDED_RIGHT_PANEL");
